import { createSelectValueList } from '../../../../util/select'

export const REDUCER_NAME = 'task-definition'

export const PRIORITY_VALUE_LIST = createSelectValueList([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 99])

export const EXTERNAL_VALUE_LIST = createSelectValueList(['physician', 'supplier', 'treatment_planer'])

export const SLA_VALUE_LIST = createSelectValueList([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 99])





// WEBPACK FOOTER //
// ./src/modules/process/state/task-definition/const.js